import React, { Component } from 'react';
import { Container, Row, Col, Form, Image, Button, Dropdown, DropdownButton,FormControl, Modal, Alert} from 'react-bootstrap';
import { store } from 'react-notifications-component';
import { Bounce } from 'react-activity';

import Connection from '../../../Calls';
import Backend from '../../../Backend';

export default class RequestPin extends Component {
  constructor(props){
    super(props)
    this.state={
      verification_code:'',
      render:'request'
    }
  }

  requestPinCode(){
    const self = this;
    this.setState({loading:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.RequestPin(localStorage.getItem('email'), localStorage.getItem('token'), '', payload.r01, response => {
        if (response.status.code === "0") {
          store.addNotification({
            title: "Success!",
            message: 'Your verification code has been via sms',
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.setState({
            render:'input',
            loading:false
          });
        }else{
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.setState({
            loading:false
          });
        };
      })
    })
  }

  sendPinCode(){
    const self = this;
    this.setState({loading:true})
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      var payload = response.payload
      Backend.RequestPin(localStorage.getItem('email'), localStorage.getItem('token'), this.state.verificationCode, payload.r01, response => {
        if (response.status.code === "0") {
          this.setState({
            render:'pin',
            pin:response.payload.pin,
            loading:false
          });
        }else{
          store.addNotification({
            title: "Error!",
            message: response.status.description,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
              duration: 1800,
              onScreen: true
            }
          });
          this.setState({
            loading:false
          });
        };
      })
    })
  }

  closeModal(){
    this.props.hideRequest()
    this.setState({
      verification_code:'',
      render:'request'
    })
  }

  render(){
    switch (this.state.render) {
      case 'request':
        return(
          <Modal centered show={this.props.show} onHide={()=>this.closeModal()}>
            <Modal.Body>
              <div className="border-title-separator-container">

                <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                  <p className="title-container-shadow">{this.props.traductions.Card.enabled.modalPin.title}</p>
                </div>
              </div>
              <Alert variant='warning'>
                {this.props.traductions.Card.enabled.modalPin.note}
              </Alert>

              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button onClick={() => { this.requestPinCode() }} className="signup-button" variant="primary" disabled={this.state.loading}>
                  {
                    (this.state.loading)
                    ?<Bounce size={20} color={"#FFFFFF"} animating={true}/>
                    :this.props.traductions.Card.enabled.modalPin.btn_Send
                  }
                </Button>
              </div>

              <p style={{marginTop:15,textAlign:'center',cursor:'pointer'}} onClick={()=>{this.setState({render:'input'})}}>{this.props.traductions.Card.enabled.modalPin.link}</p>

            </Modal.Body>
          </Modal>
        )
        break;
      case 'input':
        return(
          <Modal centered show={this.props.show} onHide={()=>this.closeModal()}>
            <Modal.Body>
              <div style={{ marginBottom:30 }} className="border-title-separator-container">

                <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                  <p className="title-container-shadow">{this.props.traductions.Card.enabled.modalPin.title2}</p>
                </div>
              </div>

              <Form.Group as={Row}>
                <Form.Label column sm="3" className="label-modal">{this.props.traductions.Card.enabled.modalPin.L_code}</Form.Label>
                <Col sm="9">
                  <Form.Control className="input-modal" type="text" placeholder={this.props.traductions.Card.enabled.modalPin.P_code} value={this.state.verificationCode} onChange={(verificationCode) => { this.setState({ verificationCode: verificationCode.target.value }); }} />
                </Col>
              </Form.Group>

              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button onClick={() => { this.sendPinCode() }} className="signup-button" variant="primary" disabled={this.state.loading}>
                  {
                    (this.state.loading)
                    ?<Bounce size={20} color={"#FFFFFF"} animating={true}/>
                    :this.props.traductions.Card.enabled.modalPin.btn_request
                  }
                </Button>
              </div>

            </Modal.Body>
          </Modal>
        )
        break;
      case 'pin':
        return(
          <Modal centered show={this.props.show} onHide={()=>this.closeModal()}>
            <Modal.Body>
              <div style={{marginBottom:30}} className="border-title-separator-container">
                <div className="border-title-separator-container-left" style={{ width: "100%" }}>
                  <p className="title-container-shadow">{this.props.traductions.Card.enabled.modalPin.success}</p>
                </div>
              </div>
              <p className="pin-text">{this.props.traductions.Card.enabled.modalPin.L_Pin}: </p>
              <p className='pin-number'> {this.state.pin}</p>
              <div style={{ marginTop: 30, textAlign: "center" }}>
                <Button onClick={()=>this.closeModal()} className="signup-button" variant="primary">
                  OK
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        )
        break;
      default:

    }
  }
}
